import { Control, Controller, Path } from 'react-hook-form';

import Input from '@/components/ui/Input';

type FormInputProps<T> = {
  name: Path<T>;
  control: Control<T>;
  placeholder?: string;
  addonBefore?: string;
  addonAfter?: string;
};

const FormInput = <T extends Record<string, any>>({ name, control, placeholder }: FormInputProps<T>) => {
  return <Controller name={name} control={control} render={({ field }) => <Input {...field} placeholder={placeholder} />} />;
};

export default FormInput;
